//initial redux
import { put, call, takeEvery, fork, all, take, takeLatest, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../services/reports";
import moment from "moment-timezone";
import pointsservice from "../../../services/points";
import {types as sitetreetypes} from "../../../services/SiteTree/redux";
import { DateTime } from "../../../utils";


const LIVE_DATA_INTERVAL = 60000;

const initialState = {
	onPage: false,
};



/////////
//types
export const types = {
	RELOAD_DATA: "components/costperhour/RELOAD_DATA",
	START_COMPONENT: "components/costperhour/START_COMPONENT",
	STOP_COMPONENT: "components/costperhour/STOP_COMPONENT",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.START_COMPONENT:{
				return {...state, chart: action.payload.chart, onPage: true};
			}
			case types.STOP_COMPONENT:{
				return {...state, onPage: false};
			}
			case types.RELOAD_DATA: {
				return state;
			}
			default:
				return state;
		}
	}
};

//turns the shitty ibms data into a timestamp-ordered array of objects
function sortCosts(hourlyCosts){
	let sorted = [];

	//if nothing then nope
	if(!hourlyCosts){
		return sorted;
	}

	for(var something in hourlyCosts) {
		if(hourlyCosts.hasOwnProperty(something)) {
			hourlyCosts[something].forEach(s => {
				sorted.push({
					timestamp: DateTime.getGMTDate(s.timestamp),
					value: s.value,
					period: something
				});
			})
		}
	}
/*
	//grab the 3 periods
	const offPeak = hourlyCosts["OffPeak"];
	const peak = hourlyCosts["Peak"];
	const shoulder = hourlyCosts["Shoulder"];

	//loop over all periods and add to same array while castign timestamps to moment objects and adding the period as a prop.
	if(offPeak && offPeak.length){
		offPeak.forEach(s => {
			sorted.push({
                timestamp: DateTime.getGMTDate(s.timestamp),
				value: s.value,
				period: "offPeak",
			});
		});
	}

	if(peak && peak.length){
		peak.forEach(s => {
			sorted.push({
                timestamp: DateTime.getGMTDate(s.timestamp),
				value: s.value,
				period: "peak",
			});
		});
	}

	if(shoulder && shoulder.length){
		shoulder.forEach(s => {
			sorted.push({
                timestamp: DateTime.getGMTDate(s.timestamp),
				value: s.value,
				period: "shoulder",
			});
		});
	}
*/
	//now sort the array
	sorted.sort(function(a, b){
		if(a.timestamp > b.timestamp){
			return 1;
		}else if (a.timestamp < b.timestamp){
			return -1;
		}else{
			return a.value - b.value;
		}
	});

	//finally, for some dumbass reason the api call returns the first hour for every period, even if it's not relevent,
	//i.e if time period requests is form 8am-10am, the peak, off-peak, and shoulder will all have values for 8am even though only 1 period should.
	//so now we need to go through and remove teh shitty entries.
	let removalCount = 0;
	for(var ii = 0; ii < sorted.length; ii++){
		//teh dodgy values should always be at start of array with value of zero.
		//Propblem is 0 is a legit value so cant just remove all 0, need to also check the datetime to make sure it's a dupe
		if(sorted[ii].value === 0
			 && ii < sorted.length - 1
			 && sorted[ii].timestamp.getTime() === sorted[ii + 1].timestamp.getTime()){
			removalCount++;
		}else{
			//shitty values are at start so no ned to loop through all valeus once we find a good value
			break;
		}
	}

	sorted.splice(0, removalCount);
	return sorted;
}

function getPeriodColor(period){
	switch(period){
		case "peak":
		case "Peak":
			return "#BFE1E7";
		case "Shoulder":
		case "shoulder":
			return  "#E9F5F7";
		default:
			return "#FFF";
	}
}

function getPeriodText(period){
	switch(period){
		case "peak": 
		case "Peak":
			return "Peak";
		case "Shoulder":
		case "shoulder":
			return  "Shoulder";
		default:
			return "";
	}
}

function drawColumns(chart, hourlyCosts, fromDate, toDate){
	if(chart && chart.xAxis && chart.xAxis[0]) {
		chart.xAxis[0].setExtremes(DateTime.getGMTDate(fromDate.format("YYYY-MM-DD HH:mm:ss")).getTime(), DateTime.getGMTDate(toDate.format("YYYY-MM-DD HH:mm:ss")).getTime())
		if(hourlyCosts && hourlyCosts.length){
			if(hourlyCosts[0].value && hourlyCosts[0].timestamp && chart.series[0] && chart.series[0].data) {
				let replace = false;
				if(chart.series[0].data.length === 0 || chart.series[0].data[0].x !== new Date(hourlyCosts[0].timestamp).getTime()) {
					// the data doesn't line up... replace
					replace = true;
					chart.series[0].update({data: []}, false);
					chart.xAxis[0].update({plotBands: []}, false);
				}

				if(replace) {
					hourlyCosts.forEach(cost => {
						if(cost && cost.value && cost.timestamp) {
							chart.series[0].addPoint({
								x: new Date(cost.timestamp).getTime(),
								y: cost.value,
							});
						}
					});
				} else {
					chart.series[0].data.forEach((d, index) => {
						if (hourlyCosts && hourlyCosts.length > index && hourlyCosts[index]) {
							d.update({
								y: hourlyCosts[index].value
							});
						}
					})
				}
			}
		}
	}
}

function drawPeriods(chart, periods){
	if(chart && chart.xAxis && chart.xAxis[0] && periods && periods.length){
		if(chart.xAxis[0].plotLinesAndBands && chart.xAxis[0].plotLinesAndBands.length === 0) {
			periods.forEach(period => {
				if(period && period.color && period.start && period.end) {
					chart.xAxis[0].addPlotBand({
						color: period.color,
						from: new Date(period.start).getTime(),
						to: new Date(period.end).getTime(),
						label: {
							text: period.text,
							style: {
								color: "#999",
							},
							y: period.text === "Peak" ? 15 : 30,
						},
					});
				}
			});
		}
	}
}

function getPeriods(hourlyCosts){
	let periods = [];
	if(!hourlyCosts || !hourlyCosts.length){
		return periods;
	}

	let wkPeriod = {
		start: hourlyCosts[0].timestamp,
		end: null,
		period: hourlyCosts[0].period,
		color: getPeriodColor(hourlyCosts[0].period),
		text: getPeriodText(hourlyCosts[0].period)
	};

	periods.push(wkPeriod);

	for(var ii = 1; ii < hourlyCosts.length; ii++){
		if(hourlyCosts[ii].period !== wkPeriod.period){
			wkPeriod.end = hourlyCosts[ii].timestamp;
			wkPeriod = {
				start: hourlyCosts[ii].timestamp,
				end: null,
				period: hourlyCosts[ii].period,
				color: getPeriodColor(hourlyCosts[ii].period),
				text: getPeriodText(hourlyCosts[ii].period)
			};
			periods.push(wkPeriod);
		}
	}

    wkPeriod.end = moment(hourlyCosts[hourlyCosts.length-1].timestamp.getTime()).add('hours', 1).toDate();
	
	return periods;
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.reloadData(),
			this.startLiveDataInterval()
		]);
	},
	*startLiveDataInterval(){
		yield takeLatest(types.START_COMPONENT, function*(){
			for(;;){
				const onPage = yield select(x => x.costperhourchart.onPage);
				if(onPage){
					yield put(actions.reloadData());
				}else{
					break;
				}
				yield delay(LIVE_DATA_INTERVAL);
			}
		});
	},
	*reloadData(){
		yield takeEvery(types.RELOAD_DATA, function*({payload}){
			const chart = yield select(x => x.costperhourchart.chart);
			const site = yield select(x => x.sitetree.currentSite);
			const tariff = yield select(x => x.tariffs.currentTariff);
			const tariffVersion = yield select(x => x.tariffs.currentTariffVersion);
			const flattenedSiteTree = yield select(x => x.sitetree.flattenedSiteTree);
			let powerUsagePointId = null;
			if(site && site._tree && site._tree.children.length && flattenedSiteTree){
				for(var ii = 0; ii < site._tree.children.length; ii++){
					let wkProp = site._tree.children[ii];
					if(flattenedSiteTree[wkProp] && flattenedSiteTree[wkProp].name === "Meters"){
                        let rec = flattenedSiteTree.First(x => x.name === "Main" && x.parentID === flattenedSiteTree[wkProp].objectID);
                        if (rec != null) {
                            powerUsagePointId = rec.objectID;
                            break;
                        }
					}
				}
			}
			//clearChart(chart);
			if(site && tariff && site.tariffId === tariff.tariffPK && powerUsagePointId){
				let fromDate = moment().subtract(1, 'days');
				let toDate = moment();
				if(site.momentTimezone){
					fromDate = moment().tz(site.momentTimezone).subtract(1, 'days').startOf('hour');
					toDate = moment().tz(site.momentTimezone).endOf('hour');
				}
				const hourlyCost = yield call(pointsservice.TrendableDataGetData, powerUsagePointId, fromDate, 'now', tariff.tariffPK, tariffVersion || null, "Hourly", true, true);
				if(hourlyCost){
					let sorted = sortCosts(hourlyCost);
					let periods = getPeriods(sorted);
					drawColumns(chart, sorted, fromDate, toDate);
					drawPeriods(chart, periods);
				}
				if(chart && chart.reflow) {
					 chart.reflow();
				}
			}
		});
	},
};

////////
//actions
export const actions = {
	startComponent(chart){
		return {
			type: types.START_COMPONENT,
			payload: {chart}
		};
	},
	stopComponent(){
		return {
			type: types.STOP_COMPONENT,
		};
	},
	reloadData(){
		return {
			type: types.RELOAD_DATA,
		};
	},
};



// WEBPACK FOOTER //
// ./src/components/LiveComponents/CostPerHourChart/redux.js